import { useSubscription } from '@apollo/client/react';
import { ScoAttachmentUserPresenceSubscriptionPayload } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { useEffect, useState } from 'react';
export const useAttachmentUserPresences = (attachmentType: string, attachmentId: string) => {
  const [presences, setPresences] = useState<{
    [key: string]: ScoAttachmentUserPresenceSubscriptionPayload;
  }>({});
  const subscription = useSubscription(gql`
      subscription ($attachmentType: String!, $attachmentId: String!) {
        scoAttachmentUserPresence(attachmentId: $attachmentId, attachmentType: $attachmentType) {
          key
          user {
            id
            pictureUrl
            fullName
            displayName
          }
          isTyping
          isOnline
        }
      }
    `, {
    variables: {
      attachmentId: attachmentId,
      attachmentType: attachmentType
    }
  });
  useEffect(() => {
    if (subscription.data?.scoAttachmentUserPresence) {
      setPresences({
        ...presences,
        [subscription.data?.scoAttachmentUserPresence.key]: subscription.data?.scoAttachmentUserPresence
      });
    }
  }, [subscription.data]);
  return presences;
};